import React from 'react';
import {
  ClaimAcknowledgementStatusDTO,
} from 'dtos';
import {
  notEmptyString,
} from '@populateui/utils';

export default function ClaimAcknowledgementContent({
  statusMessage,
  claimStatusCategoryCodeValue,
  claimStatusCategoryCode,
  statusCode,
  statusCodeValue,
}: ClaimAcknowledgementStatusDTO) {
  return (
    <>
      {notEmptyString(statusMessage) && (
        <p>
          {statusMessage}
        </p>
      )}
      <p>
        <span className="font-semibold mr-2">
          {claimStatusCategoryCode}
        </span>
        {claimStatusCategoryCodeValue}
      </p>
      <p>
        <span className="font-semibold mr-2">
          {statusCode}
        </span>
        {statusCodeValue}
      </p>
    </>
  );
}
